import { useEffect, useState } from "react";

import { getStubbedPaths, subscribeStubbedPaths } from "@/lib/stubRegistry";

export function useStubbedPaths(): string[] {
  const [paths, setPaths] = useState<string[]>(() => getStubbedPaths());

  useEffect(() => subscribeStubbedPaths(setPaths), []);

  return paths;
}
